'use client'

import { useEffect } from 'react'
import dynamic from 'next/dynamic'

import { useHolidayContext } from '@/src/contexts'
import useHolidaysGtmEvent from '@/src/hooks/analytics/gtm/holidays'
import useClevertapForHolidays from '@/src/hooks/analytics/clevertap/holidays'
import { HOLIDAY_ACTION } from '@/src/utils/analytics/holidays/holidayEvents'

const HolidayCollectionDesktopContainer = dynamic(
    () =>
        import(
            /* webpackChunkName: "HolidayCollectionDesktopContainer" */ '@/src/containers/desktop/holidays/collection'
        ),
    { ssr: true }
)

const HolidayCollectionMobileContainer = dynamic(
    () =>
        import(
            /* webpackChunkName: "HolidayCollectionMobileContainer" */ '@/src/containers/mobile/holidays/collection'
        ),
    { ssr: true }
)

const HolidayCollectionRootLoader = ({ isMobile, domainCountry }: { isMobile: boolean; domainCountry: string }) => {
    const { collectionData } = useHolidayContext()
    const { pushHolidayListPageViewEvent } = useHolidaysGtmEvent()
    const { triggerHolidayPageLoadEvent } = useClevertapForHolidays()

    // Once per load.
    useEffect(() => {
        if (!collectionData) return
        pushHolidayListPageViewEvent(collectionData.slug)
        triggerHolidayPageLoadEvent(HOLIDAY_ACTION.CATEGORY_VIEWED)
    }, [])

    return isMobile ? (
        <HolidayCollectionMobileContainer domainCountry={domainCountry} />
    ) : (
        <HolidayCollectionDesktopContainer domainCountry={domainCountry} />
    )
}

export default HolidayCollectionRootLoader
